module.exports = __webpack_public_path__ + "img/img61.db996a6e.svg";